import { Issues, Output, safeParse } from "valibot";

import { parentUrlsCallbacks } from "shared/constants";
import { debugLog, logParsedIssues } from "shared/functions";

import { EventDataSchema } from "./schemas";

export const getParsedDetail = (detailType: unknown, data: unknown) => {
  if (detailType === "string" || typeof data !== "string") {
    return data;
  }
  try {
    return JSON.parse(data);
  } catch (err) {
    debugLog("getParsedOrRaw() error", data, err);
    return data;
  }
};

const getParsedEventData = (value: unknown) => {
  if (typeof value !== "string") {
    return null;
  }
  try {
    return JSON.parse(value);
  } catch {
    debugLog("Event data was not parsed", value);
  }
  return null;
};

export const getHandleMessage =
  (
    instanceName: string,
    handleEventMessage: (eventData: Output<typeof EventDataSchema>) => void,
  ) =>
  (evt: MessageEvent) => {
    if (evt.origin === window.origin) {
      return;
    } else if (!("data" in evt) || typeof evt.data !== "string") {
      // We only use strings in events
      return;
    }
    const result = safeParse(EventDataSchema, getParsedEventData(evt.data));
    if (result.success) {
      if (result.output.instanceName !== instanceName) {
        return;
      }
      handleEventMessage(result.output);
    } else {
      debugLog("Invalid event data", evt);
      logParsedIssues(result.issues);
    }
  };

export const processParentUrlEvent = (eventDataDetail: unknown) => {
  for (const parentUrlsCallback of parentUrlsCallbacks) {
    try {
      const parentUrl = new URL(String(eventDataDetail));
      parentUrlsCallback(parentUrl);
    } catch (err) {
      debugLog("parent-url was not processed", err);
    }
  }
  parentUrlsCallbacks.length = 0;
};

export const reportSchemaIssues = (error: string, value: any, issues: Issues) =>
  // eslint-disable-next-line no-console
  console.error(error, value, issues, JSON.stringify(issues));

export const tryParseURL = (urlString?: string) => {
  try {
    return new URL(String(urlString));
  } catch {
    return new URL(window.location.href);
  }
};
